import {
  Box,
  Img,
  Text,

} from '@chakra-ui/react';
import React, { useEffect ,useState } from 'react';
import rew from 'assets/img/screens/Reward Bar.png';
import back from 'assets/img/screens/back.png';
import point from 'assets/img/screens/points.png';

import ComDesign from 'assets/img/games/Thankyou/ChapterCompleteBackgroundDesign.png';
import { getImages } from 'utils/game/gameService';

import { HashLoader } from 'react-spinners';
interface Badge {
  gasId: number;
  gasAssetImage: string;
  gasAssetName: string;
}
const CompletionScreen: React.FC<{
  formData: any;
  imageSrc: any;
  selectedBadge: any;
  compliData: any;
  setCompliData: any;
  CompKeyCount: any;
}> = ({
  imageSrc,
  compliData,

  CompKeyCount,
}) => {
  const [imgb, setbImg] = useState<any>();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem('user'));

  const ctId = userDetails?.data?.id.toString();

  useEffect(() => {
    const fetchDatass = async () => {
      if (compliData[CompKeyCount]?.gameBadge) {
        const result = await getImages(4, ctId);

        if (result?.status !== 'Success') {
          console.error('getbackground error:' + result?.message);
          return;
        }
        const selectedGasId = compliData[CompKeyCount]?.gameBadge;
        const selectedGasImage = result?.data.find(
          (gas: any) => gas.gasId == selectedGasId,
        );
        const imageUrl =
          selectedGasImage?.gasAssetImage || 'defaultImageURL.jpg';

        setbImg(imageUrl);
      }
    };

    fetchDatass(); // Call the asynchronous function
  }, [compliData]);

  return (
    <>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}

      {imageSrc && (
        <>
          <Box
            w={'100%'}
            h={'100%'}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Box
              w={'auto'}
              position={'relative'}
              h={'100%'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <Img
                src={ComDesign}
                h={'70%'}
                w={'auto'}
                transition={'transform 0.3s ease'}
                transform={{ lg: 'scale(1)', '2xl': 'scale(1.3)' }}
                onLoad={() => setLoading(false)}
              />
              <Box
                position={'absolute'}
                w={'100%'}
                transition={'transform 0.3s ease'}
                transform={{ lg: 'scale(1)', '2xl': 'scale(1.25)' }}
                h={'70%'}
                top={{ base: '21.5%', sm: '21.5%', md: '22.5%' }}
                fontFamily={'AtlantisText'}
              >
                <Text
                  textAlign={'center'}
                  textTransform={'uppercase'}
                  fontSize={{ base: '1rem' }}
                >
                  {compliData[CompKeyCount]?.gameScreenTitle}
                </Text>
                <Box
                  w={'100%'}
                  mt={'30px'}
                  display={'flex'}
                  justifyContent={'center'}
                  alignItems={'center'}
                  flexDirection={'column'}
                >
                  <Box w={'45%'}>
                    <Box className="welcome_note" textTransform={'uppercase'}>
                      {((compliData[CompKeyCount]
                        ?.gameIsSetCongratsSingleMessage === 'true' ||
                        compliData[CompKeyCount]
                          ?.gameIsSetCongratsSingleMessage === undefined) &&
                        compliData[CompKeyCount]
                          ?.gameIsSetCongratsScoreWiseMessage === 'false') ||
                      (compliData[CompKeyCount]
                        ?.gameIsSetCongratsSingleMessage === 'false' &&
                        compliData[CompKeyCount]
                          ?.gameIsSetCongratsScoreWiseMessage === 'false') ||
                      (compliData[CompKeyCount]?.gameIsSetDistinctionScore ===
                        'false' &&
                        compliData[CompKeyCount]?.gameIsSetMinPassScore ===
                          'false') ? (
                        <>
                          {compliData[CompKeyCount]
                            ?.gameCompletedCongratsMessage ||
                            'Congratulations! You have Completed...'}
                        </>
                      ) : (
                        <></>
                      )}
                      {compliData[CompKeyCount]
                        ?.gameIsSetCongratsScoreWiseMessage === 'true' &&
                      compliData[CompKeyCount]?.gameIsSetDistinctionScore ===
                        'true' &&
                      compliData[CompKeyCount]?.gameIsSetMinPassScore ===
                        'false' ? (
                        <>
                          {
                            compliData[CompKeyCount]
                              ?.gameAboveDistinctionScoreCongratsMessage
                          }
                        </>
                      ) : (
                        <></>
                      )}

                      {compliData[CompKeyCount]
                        ?.gameIsSetCongratsScoreWiseMessage === 'true' &&
                      compliData[CompKeyCount]?.gameIsSetDistinctionScore ===
                        'true' &&
                      compliData[CompKeyCount]?.gameIsSetMinPassScore ===
                        'true' ? (
                        <>
                          {
                            compliData[CompKeyCount]
                              ?.gameAboveDistinctionScoreCongratsMessage
                          }{' '}
                        </>
                      ) : (
                        <></>
                      )}
                      {compliData[CompKeyCount]
                        ?.gameIsSetCongratsScoreWiseMessage === 'true' &&
                      compliData[CompKeyCount]?.gameIsSetMinPassScore ===
                        'true' &&
                      compliData[CompKeyCount]?.gameIsSetDistinctionScore ===
                        'false' ? (
                        <>
                          {
                            compliData[CompKeyCount]
                              ?.gameaboveMinimumScoreCongratsMessage
                          }
                        </>
                      ) : (
                        <></>
                      )}
                      {compliData[CompKeyCount]
                        ?.gameCompletedCongratsMessage === '' && (
                        <>
                          <div style={{ height: '100px' }}></div>
                        </>
                      )}
                    </Box>
                  </Box>
                  <Box
                    w={'100%'}
                    mt={'10px'}
                    display={'flex'}
                    justifyContent={'center'}
                  >
                    <Img w={'58%'} h={'auto'} src={rew} />
                  </Box>
                  <Box className="points-box">
                    <Box className="box-1">
                      <Img src={back} className="box-1_img" />
                      <Text className="points-text" fontFamily={'content'}>
                        Points
                      </Text>
                      <Box className="inside-box-1">
                        <Img src={point} className="inside-box-1_img" />
                        <Text
                          className="inside-points-text"
                          fontFamily={'content'}
                        >
                          {(compliData[CompKeyCount]?.gameMinScore || 0) +
                            '/' +
                            (compliData[CompKeyCount]?.gameTotalScore
                              ? compliData[CompKeyCount]?.gameTotalScore || 100
                              : '')}
                        </Text>
                      </Box>
                    </Box>
                    {compliData[CompKeyCount]?.gameIsSetBadge === 'true' && (
                      <Box className="box-2">
                        <Img src={back} className="box-2_img" />
                        <Text className="points-text" fontFamily={'content'}>
                          {compliData[CompKeyCount]?.gameBadgeName}
                        </Text>
                        {compliData[CompKeyCount]?.gameBadge && (
                          <Img className="inside-img" src={imgb} />
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </>
      )}
    </>
  );
};
export default CompletionScreen;
